import {
  Job,
  JobAssignees
} from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;
import { JobPatch } from '../../../../build/mpro-job-components/types/interfaces/advanced-editor.interface';
import { AutoGenerateJobDataResponseModel, AutoGenerateCloneJobDataResponseModel } from '@crimsontide/core/client/response-models';

let dotNetObj: DotNetObject;

export const JobService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobs = async (startDate?: Date, endDate?: Date, batchNumber: number = 0, includeRecurring: Boolean = false): Promise<Job[]> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<Job[]>('GetAsync', startDate, endDate, batchNumber, includeRecurring);
  };

  const getRecurringJobs = async (startDate?: Date, endDate?: Date, batchNumber: number = 0): Promise<Job[]> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<Job[]>('GetRecurringAsync', startDate, endDate, batchNumber);
  };

  const getAssigneesForJob = async (): Promise<JobAssignees> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<JobAssignees>('GetAssigneesForJobAsync');
  };

  const deleteJob = async (jobId: string): Promise<Job[]> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<Job[]>('DeleteByIdAsync', jobId);
  };

  const removeRecurringJobInstance = async (parentJobId: string, startDate: Date): Promise<Job[]> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<Job[]>('RemoveRecurringJobInstanceAsync', parentJobId, startDate);
  };

  const createRecurringJobOccurrence = async (addOperation: JobPatch, updateOperation: JobPatch): Promise<Job[]> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<Job[]>('CreateRecurringJobOccurrenceAsync', addOperation, updateOperation);
  };

  const autoGenerateNewJobData = async (): Promise<AutoGenerateJobDataResponseModel> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<AutoGenerateJobDataResponseModel>('AutoGenerateNewJobDataAsync');
  };

  const autoGenerateCloneJobData = async (jobId: string): Promise<AutoGenerateCloneJobDataResponseModel> => {
    validateDotNetObjectReference()
    return await dotNetObj.invokeMethodAsync<AutoGenerateCloneJobDataResponseModel>('AutoGenerateCloneJobDataAsync', jobId);
  };

  const validateDotNetObjectReference = () => {
    if (!dotNetObj) {
      throw 'Job DotNet Object Reference has not yet been implemented';
    }
  }

  return {
    setDotNetReference,
    getJobs,
    getRecurringJobs,
    getAssigneesForJob,
    deleteJob,
    removeRecurringJobInstance,
    createRecurringJobOccurrence,
    autoGenerateNewJobData,
    autoGenerateCloneJobData
  };
})();
